//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryCategories,
  queryVolunteer,
  queryVolunteerEnrollNumber,
  updateVolunteer,
} from '@/https/enroll'
import { success } from '@/utils/notify.js'
import { toast } from '@/utils/toast'
import { uniq } from '@/utils/lodash'
import {
  CategorySelect,
  Select,
} from '@/constant/componentConfig'
import { whether } from '@/constant/dict'
import { danger } from '@/utils/notify'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      wishNum: 0,
      wishList: [],
      wishInfo: {},
      loading: false,
    }
  },

  computed: {
    renderData () {
      const self = this
      const { syszddm } = this.wishInfo || {}
      const { pcdm, dzlbdm } = this.$route.query
      const wishRender = new Array(this.wishNum).fill({})
        .map((wish, index) => {
          const num = index + 1

          return new Select({
            label: `专业志愿${num}`,
            value: `zsjh${num}Wid`,
            name: `zsjh${num}Wid`,
            required: num === 1,
            dataPath: 'data',
            list: this.wishList,
            readonly: +this.options.bmbMbDetailItem.zysfzddm === 1,
            beforeConfirm: (val) => {
              let flag = true

              for (let i = 1; i <= self.wishNum; i++) {
                if (val && (val === self.wishInfo[`zsjh${i}Wid`]) && num !== i) {
                  toast('所选专业不能重复')
                  this.wishInfo[`zsjh${num}Wid`] = ''
                  flag = false

                  break
                }
              }

              return flag
            },
          })
        })

      const adjustSelect = +this.options?.bmbMbDetailItem?.sfkttjzydm ? [
        new Select({
          label: '是否服从调剂',
          value: 'sftjdm',
          name: 'sfkttjzydm',
          required: true,
          list: whether,
          readonly: +this.options.bmbMbDetailItem.tjsfzddm === 1
        }),
      ] : []

      return [
        new CategorySelect({
          value: 'xbkldm',
          readonly: +this.options.bmbMbDetailItem.zysfzddm === 1,
          clear: new Array(this.wishNum)
            .fill({})
            .map((el, index) => `zsjh${index + 1}Wid`),
          params: {
            pcdm,
            dzlbdm,
          },
          apiMethod: queryCategories,
          _onChange: (val) => {
            this.setWishList({
              xbkldm: val,
              syszddm,
            })

            this.setWishNumber({ xbkldm: val })
          },
        }),
        ...wishRender,
        ...adjustSelect,
      ]
    },
  },

  watch: {
    'options.ksxxItem': {
      handler (val) {
        if (val.wid) {
          if (val instanceof Object) {
            const keys = [
              'sftjdm',
              'xbkldm',
              'syszddm',
            ]

            Object.keys(val).forEach((key) => {
              if (keys.includes(key) || key.indexOf('zsjh') >= 0) {
                this.$set(this.wishInfo, key, val[key])
              }
            })
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    async setWishNumber (params) {
      const { pcdm, dzlbdm } = this.$route.query
      const { data } = await queryVolunteerEnrollNumber({
        dzlbdm,
        pcdm,
        ...params,
      })

      this.wishNum = +data || 6
    },

    async setWishList (params = {}) {
      const { pcdm, dzlbdm } = this.$route.query
      const wishParams = {
        pcdm,
        dzlbdm,
        xbkldm: params.xbkldm,
        syszddm: params.syszddm,
        ...params,
      }

      if (!wishParams.xbkldm) {
        this.wishList = []

        return
      }

      const { data } = await queryVolunteer(wishParams)

      this.wishList = data || []
    },

    async _validate () {
      const chooseWish = Object.keys(this.wishInfo).map((key) => {
        if (key.indexOf('zsjh') >= 0) {
          return this.wishInfo[key]
        }
      })
        .filter((el) => el)

      if (uniq(chooseWish).length !== chooseWish.length) {
        toast(
          '所选专业不能重复'
        )

        return false
      }

      const flag = await this.$refs.volunteerForm.validate()

      return flag
    },

    async save () {
      const data = await this.$refs.volunteerForm.validate()

      if (!data) {
        return false
      }

      const { code, message } = await updateVolunteer({
        ksWid: this.options.ksxxItem.wid,
        ...this.wishInfo,
      })

      if (+code === 0) {
        success('保存成功')
        setTimeout((e) => {
          this.$emit('on-back')
        }, 400)
      } else {
        danger(message)
      }
    },
  },
}
